import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconIntegrationGuide: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.73394 4.96872C3.73394 4.60158 4.04574 4.30395 4.43037 4.30395H7.21608C7.60071 4.30395 7.91251 4.60158 7.91251 4.96872C7.91251 5.33586 7.60071 5.63349 7.21608 5.63349H4.43037C4.04574 5.63349 3.73394 5.33586 3.73394 4.96872Z"
      fill="currentColor"
    />
    <path
      d="M4.43037 6.63033C4.04574 6.63033 3.73394 6.92796 3.73394 7.2951C3.73394 7.66224 4.04574 7.95987 4.43037 7.95987H8.60894C8.99357 7.95987 9.30537 7.66224 9.30537 7.2951C9.30537 6.92796 8.99357 6.63033 8.60894 6.63033H4.43037Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.38572 16.2695C2.42417 16.2695 1.64465 15.5255 1.64465 14.6076V3.30646C1.64465 2.3886 2.42416 1.64453 3.38572 1.64453H11.7429C12.7045 1.64453 13.4839 2.38861 13.4839 3.30646V7.62749H14.8768C15.6461 7.62749 16.2697 8.22273 16.2697 8.95703V14.6076C16.2697 15.5255 15.4902 16.2695 14.5286 16.2695H3.38572ZM3.03751 3.30646C3.03751 3.12289 3.19341 2.97408 3.38572 2.97408H11.7429C11.9352 2.97408 12.0911 3.12289 12.0911 3.30646V14.94H3.38572C3.19341 14.94 3.03751 14.7912 3.03751 14.6076V3.30646ZM13.4839 8.95703V14.94H14.5286C14.7209 14.94 14.8768 14.7912 14.8768 14.6076V8.95703H13.4839Z"
      fill="currentColor"
    />
  </svg>
);
